import { Card } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { sumUpArray } from '../../../utils/arrayFunc';
import { formatNumber } from '../../../utils/helper';
import { useCurriculum } from '../hooks/useCurriculum';
import styles from './CurriculumStats.module.scss';

type CurriculumGradeStatsProps = {
  curriculumUuid: string | undefined;
  grade: string | undefined;
};

export const CurriculumGradeStats = ({ curriculumUuid, grade }: CurriculumGradeStatsProps) => {
  const { t } = useTranslation();

  const { tableData } = useCurriculum({
    versionUuid: curriculumUuid ?? '',
    grade: grade,
  });

  const studentsHours = sumUpArray(tableData.map((c) => c?.curriculumInfo?.studentHours ?? 0));
  const teachersHours = sumUpArray(tableData.map((c) => c?.curriculumInfo?.teacherHours ?? 0));
  const deputateSubjectContainer = sumUpArray(tableData.map((c) => c?.curriculumInfo?.epochenDeputat ?? 0));
  const deputateLessonUnit = sumUpArray(tableData.map((c) => c?.curriculumInfo?.fachstundenDeputat ?? 0));

  return (
    <Card wrapperClass={styles['curriculum-stats']} className={styles.content} fitContent contentPadding='none'>
      <div className={styles.stats}>
        <div className={styles.stat}>
          <div>{t('subjectHours.studentHours')}</div>
          <div>{formatNumber(studentsHours)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('subjectHours.teacherHours')}</div>
          <div>{formatNumber(teachersHours)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('deputate.deputateSubject')}</div>
          <div>{formatNumber(deputateLessonUnit)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('deputate.deputateEpoch')}</div>
          <div>{formatNumber(deputateSubjectContainer)}</div>
        </div>
        <div className={styles.stat}>
          <div>{t('deputate.deputateTotal')}</div>
          <div>{formatNumber(deputateSubjectContainer + deputateLessonUnit)}</div>
        </div>
      </div>
    </Card>
  );
};
